import { AppEnv } from "@/types/monitoring";

// Every deployed build (dev/beta/qa/prod) runs `vite build`, so import.meta.env.PROD is
// true everywhere — it only tells us "this isn't a local dev server", not which environment
// this is. Reporting is further restricted to BETA/QA/PROD via VITE_ENV_NAME, so dev/local
// stay console-only. Shared by AppLogger.ts and appInsightsConfig.ts.
const REPORTABLE_ENVIRONMENTS: ReadonlySet<AppEnv> = new Set([AppEnv.QA, AppEnv.PROD, AppEnv.BETA]);

export const isReportableEnvironment = () => {
  if (!import.meta.env.PROD) return false;

  const env = import.meta.env.VITE_ENV_NAME as AppEnv | undefined;
  return !!env && REPORTABLE_ENVIRONMENTS.has(env);
};
